var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaHideIconType30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 61,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7085 108.291C43.9866 110.57 47.68 110.57 49.9581 108.291L75 83.2496L100.042 108.291C102.32 110.57 106.014 110.57 108.292 108.291C110.569 106.013 110.569 102.32 108.292 100.042L83.2496 75L108.292 49.9581C110.569 47.6801 110.569 43.9864 108.292 41.7085C106.014 39.4305 102.32 39.4305 100.042 41.7085L75 66.7504L49.9581 41.7085C47.68 39.4305 43.9866 39.4305 41.7085 41.7085C39.4305 43.9864 39.4305 47.6801 41.7085 49.9581L66.7504 75L41.7085 100.042C39.4305 102.32 39.4305 106.013 41.7085 108.291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaHideIconType30);
export default __webpack_public_path__ + "static/media/aioa-hide-icon-type-30.a55a889a842dc6c1ffcfdb2ead8918f6.svg";
export { ForwardRef as ReactComponent };